<template>
  <div class="footer left-1-md">
    <div class="row footer__links">
      <router-link :to="prev" class="col-2 footer__link">Prev</router-link>
      <router-link :to="next" class="col-2 left-2 left-0-md footer__link">Next</router-link>
    </div>
    <span class="footer__copy">&copy; {{ year }} Thank Your For Clapping</span>
  </div>
</template>

<script>
export default {
  name: 'project-footer',
  props: ['prev', 'next'],
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="sass" scoped>

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

.footer
  padding-bottom: 50px
  +medium
    padding-bottom: 25px

.footer__links
  font-weight: 700
  text-transform: uppercase
  font-size: 1.2rem
  margin-bottom: 50px
  margin-top: 50px
  +medium
    margin-top: 75px
    margin-bottom: 90px

.footer__link
  color: $black
  text-decoration: none

.footer__copy
  font-weight: 500
  font-size: 0.7rem

</style>



// WEBPACK FOOTER //
// Footer.vue?64f0483e